import {inject, injectable} from 'inversify'
import {makeObservable, observable, runInAction, computed} from 'mobx'
import {notification} from 'antd'
import {useAuthStore} from '@/stores'
import {sendEmailOtp, validateEmailOtp} from '@/stores/profile/services/fetchers'
import {TwoFAStoreInterface, TwoFAStoreSymbol} from '@/pages/Profile/components/TwoFA'
import {TwoFAEmailConfirmationModalStoreInterface} from './TwoFAEmailConfirmationModalStoreInterface'
import {captureSentryError, getErrorMessage} from '@/services/sentry-helper'

@injectable()
export class TwoFAEmailConfirmationModalStore implements TwoFAEmailConfirmationModalStoreInterface {
    public twoFAStore: TwoFAStoreInterface
    public isLoading: boolean = false

    constructor(@inject(TwoFAStoreSymbol) twoFAStore: TwoFAStoreInterface) {
        this.twoFAStore = twoFAStore

        makeObservable(this, {
            isLoading: observable,
            email: computed
        })
    }

    get email() {
        return useAuthStore().email
    }

    verifyEmailOtp = async (code: string): Promise<boolean> => {
        try {
            const {error} = await validateEmailOtp(code)

            if (error) {
                notification.error({message: error.message})

                return false
            }

            this.twoFAStore.setIsEmailConfirmationModalOpen(false)
            this.twoFAStore.setIsModalOpen(true)

            return true
        } catch (error) {
            captureSentryError({
                name: 'Email OTP Verification Error',
                description: getErrorMessage(error, 'Email OTP verification failed'),
                fingerprint: ['twofa-email-otp-verify'],
                error
            })
            return false
        }
    }

    resendEmailOtp = async () => {
        runInAction(() => (this.isLoading = true))
        try {
            await sendEmailOtp()
        } catch (error) {
            captureSentryError({
                name: 'Email OTP Resend Error',
                description: getErrorMessage(error, 'Email OTP resend failed'),
                fingerprint: ['twofa-email-otp-resend'],
                error
            })
        } finally {
            runInAction(() => (this.isLoading = false))
        }
    }
}
